module.exports = __webpack_public_path__ + "img/emotional_wellbeing.2b51745e.png";